@if (incomeTaxEntity$ | async) {
  <form (change)="saveForm()" [formGroup]="formGroup">
    @if (ondernemingen.length > 0) {
      <div formArrayName="ondernemingen">
        @for (item of ondernemingen.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <div class="col-auto">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Naam' : ''"
                                              class="custom-input-250"
                                              formControlName="naam"
                                              id="naam"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-text-form-control [label]="i === 0 ? 'Werkzaamheden' : ''"
                                              class="custom-input-250"
                                              formControlName="werkzaamheden"
                                              id="werkzaamheden"
                                              maxlength="70"
              >
              </snelstart-ui-text-form-control>
            </div>
            <div class="col-auto">
              <snelstart-ui-select-form-control [label]="i === 0 ? 'Ondernemingsvorm' : ''"
                                                [options]="ondernemingsvorm"
                                                class="custom-input-250"
                                                formControlName="ondernemingsvorm"
              >
              </snelstart-ui-select-form-control>
            </div>
            @if (isDefAangifte) {
              <snelstart-ui-button (click)="this.navigateToSubPage(i)"
                                   [class]="i === 0 ? 'pt-3 col-auto' : 'col-auto'"
                                   icon="plus"
                                   [disabled]="!item.get('ondernemingsvorm')?.value"
                                   type="secondary">
                Invullen onderneming
              </snelstart-ui-button>
            }
            @if (!isDefAangifte) {
              <snelstart-ui-number-form-control [decimals]="0"
                                                [label]="i === 0 ? 'Winst' : ''"
                                                align="right"
                                                class="custom-input-250"
                                                formControlName="onttrekkingenOverig"
                                                id="onttrekkingenOverig"
                                                prefix="€"
              >
              </snelstart-ui-number-form-control>
            }
            <div class="col-auto">
              <snelstart-ui-button (click)="verwijderRij(i)"
                                   [class]="i === 0 ? 'firstrowbutton' : ''"
                                   icon="trash"
                                   iconType="light"
                                   id="delete"
                                   size="medium"
                                   type="secondary"
              >
              </snelstart-ui-button>
            </div>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                       type="link">Onderneming toevoegen
  </snelstart-ui-button>
}

